import style from './EventCalendarMonth.scss'
import EventCalendarDayitem from '../EventCalendarDayitem/EventCalendarDayitem.js'

export default class EventCalendarMonth extends React.Component {
  render() {
    return (
      <div class="m-eventcalender__month">
        <div class="m-eventcalender__month__title">{this.props.month.name}</div>
        <ul class="m-eventcalender__month__days">
          {this.props.month.days.map(day => <li class="m-eventcalender__month__day"><EventCalendarDayitem eventCalendar={this.props.eventCalendar} day={day} controller={this.props.controller} /></li>)}
        </ul>
      </div>
    );
  }
}
